module.exports = __webpack_public_path__ + "static/media/Foundation.e20945d7.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-web-vector-icons/fonts/Foundation.ttf
 ** module id = 915
 ** module chunks = 0
 **/